export interface Project {
  id: number;
  title: string;
  descriptionKey: string;
  technologies: string[];
  demo: string;
  github: string;
  category: string;
  date: string;
  type: string;
}

export const projects: Project[] = [
  {
    id: 1,
    title: "3D Model Viewer",
    descriptionKey: "projects.descriptions.vue3dModelViewer",
    technologies: ["Vue.js", "Three.js", "Vite", "Docker"],
    demo: "https://github.com/TheMilize/vue-3d-model-viewer",
    github: "https://github.com/TheMilize/vue-3d-model-viewer",
    category: "frontend",
    date: "2026",
    type: "personal",
  },
  {
    id: 2,
    title: "Office Space Frontend",
    descriptionKey: "projects.descriptions.officeSpaceFrontend",
    technologies: ["Vue.js", "TypeScript", "CSS3"],
    demo: "https://github.com/TheMilize/office_space_f",
    github: "https://github.com/TheMilize/office_space_f",
    category: "frontend",
    date: "2025",
    type: "personal",
  },
  {
    id: 3,
    title: "Office Space Backend",
    descriptionKey: "projects.descriptions.officeSpaceBackend",
    technologies: ["Node.js", "TypeScript", "PostgreSQL"],
    demo: "https://github.com/TheMilize/office_space_b",
    github: "https://github.com/TheMilize/office_space_b",
    category: "backend",
    date: "2025",
    type: "personal",
  },
  {
    id: 4,
    title: "REST API Service",
    descriptionKey: "projects.descriptions.restApi",
    technologies: ["Node.js", "Express.js", "MongoDB", "JWT"],
    demo: "#",
    github: "#",
    category: "backend",
    date: "2024",
    type: "commercial",
  },
  {
    id: 5,
    title: "Weather Dashboard",
    descriptionKey: "projects.descriptions.weatherDashboard",
    technologies: ["Vue.js", "Chart.js", "OpenWeather API"],
    demo: "#",
    github: "#",
    category: "frontend",
    date: "2023",
    type: "personal",
  },
  {
    id: 6,
    title: "Mobile App",
    descriptionKey: "projects.descriptions.mobileApp",
    technologies: ["React Native", "Node.js", "MongoDB"],
    demo: "#",
    github: "#",
    category: "mobile",
    date: "2023",
    type: "commercial",
  },
  {
    id: 7,
    title: "Portfolio Website",
    descriptionKey: "projects.descriptions.portfolio",
    technologies: ["Vue.js", "CSS3", "Vite"],
    demo: "#",
    github: "#",
    category: "frontend",
    date: "2024",
    type: "personal",
  },
  {
    id: 8,
    title: "DnD Character Generator",
    descriptionKey: "projects.descriptions.dnd",
    technologies: ["React.js", "JavaScript", "CSS3"],
    demo: "https://github.com/TheMilize/dnd_randomizer",
    github: "https://github.com/TheMilize/dnd_randomizer",
    category: "fullstack",
    date: "2024",
    type: "personal",
  },
  {
    id: 9,
    title: "Memory Game",
    descriptionKey: "projects.descriptions.memory",
    technologies: ["Vue.js", "JavaScript", "CSS3"],
    demo: "https://github.com/TheMilize/memory_game",
    github: "https://github.com/TheMilize/memory_game",
    category: "fullstack",
    date: "2023",
    type: "personal",
  },
  {
    id: 10,
    title: "Effective Mobile Frontend",
    descriptionKey: "projects.descriptions.effectiveFrontend",
    technologies: ["Vue.js", "TypeScript", "CSS3"],
    demo: "https://github.com/TheMilize/effective_mobile_ts_f",
    github: "https://github.com/TheMilize/effective_mobile_ts_f",
    category: "frontend",
    date: "2024",
    type: "commercial",
  },
  {
    id: 11,
    title: "Effective Mobile Backend",
    descriptionKey: "projects.descriptions.effectiveBackend",
    technologies: ["Node.js", "TypeScript", "Express"],
    demo: "https://github.com/TheMilize/effective_mobile_ts_b",
    github: "https://github.com/TheMilize/effective_mobile_ts_b",
    category: "backend",
    date: "2024",
    type: "commercial",
  },
  {
    id: 12,
    title: "E-commerce Platform",
    descriptionKey: "projects.descriptions.ecommerce",
    technologies: ["Vue.js", "Node.js", "PostgreSQL", "Stripe"],
    demo: "#",
    github: "#",
    category: "fullstack",
    date: "2024",
    type: "commercial",
  },
  {
    id: 13,
    title: "Task Management App",
    descriptionKey: "projects.descriptions.taskManagement",
    technologies: ["Vue.js", "TypeScript", "Firebase", "CSS3"],
    demo: "#",
    github: "#",
    category: "frontend",
    date: "2024",
    type: "personal",
  },
];

export const featuredProjects = projects.slice(0, 3);
